 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-assets-icon-iconfont":"view-assets-icon-iconfont","view-assets-icon-iconfont-eot":"view-assets-icon-iconfont-eot","view-assets-icon-iconfont-json":"view-assets-icon-iconfont-json","view-assets-icon-iconfont-svg":"view-assets-icon-iconfont-svg","view-assets-icon-iconfont-ttf":"view-assets-icon-iconfont-ttf","view-assets-icon-iconfont-woff":"view-assets-icon-iconfont-woff","view-assets-icon-iconfont-woff2":"view-assets-icon-iconfont-woff2","view-assets-images-bg-png":"view-assets-images-bg-png","view-assets-images-header-login_button-png":"view-assets-images-header-login_button-png","view-assets-images-header-login_button_hover-png":"view-assets-images-header-login_button_hover-png","view-assets-images-home-l-focus-png":"view-assets-images-home-l-focus-png","view-assets-images-home-l-hover-png":"view-assets-images-home-l-hover-png","view-assets-images-home-l-normal-png":"view-assets-images-home-l-normal-png","view-assets-images-home-like-png":"view-assets-images-home-like-png","view-assets-images-home-r-focus-png":"view-assets-images-home-r-focus-png","view-assets-images-home-r-hover-png":"view-assets-images-home-r-hover-png","view-assets-images-home-r-normal-png":"view-assets-images-home-r-normal-png","view-assets-images-home-search_bg-png":"view-assets-images-home-search_bg-png","view-assets-images-home-search_button-png":"view-assets-images-home-search_button-png","view-assets-images-home-search_button_hover-png":"view-assets-images-home-search_button_hover-png","view-assets-images-home-search_button_icon-png":"view-assets-images-home-search_button_icon-png","view-assets-images-home-share-png":"view-assets-images-home-share-png","view-assets-images-home-shares-png":"view-assets-images-home-shares-png","view-assets-images-home-sort_button_01-png":"view-assets-images-home-sort_button_01-png","view-assets-images-home-sort_button_01_hover-png":"view-assets-images-home-sort_button_01_hover-png","view-assets-images-home-to_home-png":"view-assets-images-home-to_home-png","view-assets-images-home-to_home_hover-png":"view-assets-images-home-to_home_hover-png","view-assets-images-login-modal-png":"view-assets-images-login-modal-png","view-assets-images-login-yostar-png":"view-assets-images-login-yostar-png","view-assets-images-vote_mask-no-png":"view-assets-images-vote_mask-no-png","view-assets-images-vote_mask-vote_bg-png":"view-assets-images-vote_mask-vote_bg-png","view-assets-images-vote_mask-yes-png":"view-assets-images-vote_mask-yes-png","view-assets-images-watch-share-png":"view-assets-images-watch-share-png","view-assets-images-watch-share_hover-png":"view-assets-images-watch-share_hover-png","view-assets-scss-variables-scss":"view-assets-scss-variables-scss","view-components-Textarea":"view-components-Textarea","view-components-VoteMask":"view-components-VoteMask","view-components-toHome":"view-components-toHome","view-views-404":"view-views-404","view-views-Home":"view-views-Home","view-views-Home-components-Pagination":"view-views-Home-components-Pagination","view-views-PrivacyPolicy":"view-views-PrivacyPolicy","view-views-Rules":"view-views-Rules","view-views-TermsOfService":"view-views-TermsOfService","view-views-Upload":"view-views-Upload","view-views-Upload-components-Stage1":"view-views-Upload-components-Stage1","view-views-Upload-components-Stage2":"view-views-Upload-components-Stage2","view-views-Upload-components-Stage3":"view-views-Upload-components-Stage3","view-views-Watch":"view-views-Watch"}[chunkId]||chunkId) + "." + {"view-assets-icon-iconfont":"a3392a3e","view-assets-icon-iconfont-eot":"9d537821","view-assets-icon-iconfont-json":"b59d9073","view-assets-icon-iconfont-svg":"5a4597fa","view-assets-icon-iconfont-ttf":"1c31d84d","view-assets-icon-iconfont-woff":"a000c61a","view-assets-icon-iconfont-woff2":"852ecf1e","view-assets-images-bg-png":"4600e6f1","view-assets-images-header-login_button-png":"8c4f28b0","view-assets-images-header-login_button_hover-png":"d9fd8226","view-assets-images-home-l-focus-png":"6f5e9f2d","view-assets-images-home-l-hover-png":"81f21df0","view-assets-images-home-l-normal-png":"c039748d","view-assets-images-home-like-png":"7e678ea7","view-assets-images-home-r-focus-png":"2680e8c4","view-assets-images-home-r-hover-png":"e40408d2","view-assets-images-home-r-normal-png":"bcbae736","view-assets-images-home-search_bg-png":"a856d63a","view-assets-images-home-search_button-png":"e36139e5","view-assets-images-home-search_button_hover-png":"dbf8ef0d","view-assets-images-home-search_button_icon-png":"a90931dd","view-assets-images-home-share-png":"543acfb3","view-assets-images-home-shares-png":"c9384959","view-assets-images-home-sort_button_01-png":"d22a8fcf","view-assets-images-home-sort_button_01_hover-png":"7027a0a1","view-assets-images-home-to_home-png":"bf24d55b","view-assets-images-home-to_home_hover-png":"518181f6","view-assets-images-login-modal-png":"5d1a81a0","view-assets-images-login-yostar-png":"72664bc2","view-assets-images-vote_mask-no-png":"c963d172","view-assets-images-vote_mask-vote_bg-png":"7b6d340e","view-assets-images-vote_mask-yes-png":"21f1d35a","view-assets-images-watch-share-png":"b1abcb9f","view-assets-images-watch-share_hover-png":"f457a0fb","view-assets-scss-variables-scss":"53f2f772","view-components-Textarea":"4cb15df1","view-components-VoteMask":"da725ce7","view-components-toHome":"d104d4bb","view-views-404":"83b961ae","view-views-Home":"7d5a35c0","view-views-Home-components-Pagination":"54259875","view-views-PrivacyPolicy":"3102a8af","view-views-Rules":"28272e91","view-views-TermsOfService":"a2a85462","view-views-Upload":"54f58b88","view-views-Upload-components-Stage1":"23ddb389","view-views-Upload-components-Stage2":"5199b712","view-views-Upload-components-Stage3":"4c6ccd34","view-views-Watch":"9a865dd1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-assets-scss-variables-scss":1,"view-components-Textarea":1,"view-components-VoteMask":1,"view-components-toHome":1,"view-views-404":1,"view-views-Home":1,"view-views-Home-components-Pagination":1,"view-views-PrivacyPolicy":1,"view-views-Rules":1,"view-views-TermsOfService":1,"view-views-Upload":1,"view-views-Upload-components-Stage1":1,"view-views-Upload-components-Stage2":1,"view-views-Upload-components-Stage3":1,"view-views-Watch":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-assets-icon-iconfont":"view-assets-icon-iconfont","view-assets-icon-iconfont-eot":"view-assets-icon-iconfont-eot","view-assets-icon-iconfont-json":"view-assets-icon-iconfont-json","view-assets-icon-iconfont-svg":"view-assets-icon-iconfont-svg","view-assets-icon-iconfont-ttf":"view-assets-icon-iconfont-ttf","view-assets-icon-iconfont-woff":"view-assets-icon-iconfont-woff","view-assets-icon-iconfont-woff2":"view-assets-icon-iconfont-woff2","view-assets-images-bg-png":"view-assets-images-bg-png","view-assets-images-header-login_button-png":"view-assets-images-header-login_button-png","view-assets-images-header-login_button_hover-png":"view-assets-images-header-login_button_hover-png","view-assets-images-home-l-focus-png":"view-assets-images-home-l-focus-png","view-assets-images-home-l-hover-png":"view-assets-images-home-l-hover-png","view-assets-images-home-l-normal-png":"view-assets-images-home-l-normal-png","view-assets-images-home-like-png":"view-assets-images-home-like-png","view-assets-images-home-r-focus-png":"view-assets-images-home-r-focus-png","view-assets-images-home-r-hover-png":"view-assets-images-home-r-hover-png","view-assets-images-home-r-normal-png":"view-assets-images-home-r-normal-png","view-assets-images-home-search_bg-png":"view-assets-images-home-search_bg-png","view-assets-images-home-search_button-png":"view-assets-images-home-search_button-png","view-assets-images-home-search_button_hover-png":"view-assets-images-home-search_button_hover-png","view-assets-images-home-search_button_icon-png":"view-assets-images-home-search_button_icon-png","view-assets-images-home-share-png":"view-assets-images-home-share-png","view-assets-images-home-shares-png":"view-assets-images-home-shares-png","view-assets-images-home-sort_button_01-png":"view-assets-images-home-sort_button_01-png","view-assets-images-home-sort_button_01_hover-png":"view-assets-images-home-sort_button_01_hover-png","view-assets-images-home-to_home-png":"view-assets-images-home-to_home-png","view-assets-images-home-to_home_hover-png":"view-assets-images-home-to_home_hover-png","view-assets-images-login-modal-png":"view-assets-images-login-modal-png","view-assets-images-login-yostar-png":"view-assets-images-login-yostar-png","view-assets-images-vote_mask-no-png":"view-assets-images-vote_mask-no-png","view-assets-images-vote_mask-vote_bg-png":"view-assets-images-vote_mask-vote_bg-png","view-assets-images-vote_mask-yes-png":"view-assets-images-vote_mask-yes-png","view-assets-images-watch-share-png":"view-assets-images-watch-share-png","view-assets-images-watch-share_hover-png":"view-assets-images-watch-share_hover-png","view-assets-scss-variables-scss":"view-assets-scss-variables-scss","view-components-Textarea":"view-components-Textarea","view-components-VoteMask":"view-components-VoteMask","view-components-toHome":"view-components-toHome","view-views-404":"view-views-404","view-views-Home":"view-views-Home","view-views-Home-components-Pagination":"view-views-Home-components-Pagination","view-views-PrivacyPolicy":"view-views-PrivacyPolicy","view-views-Rules":"view-views-Rules","view-views-TermsOfService":"view-views-TermsOfService","view-views-Upload":"view-views-Upload","view-views-Upload-components-Stage1":"view-views-Upload-components-Stage1","view-views-Upload-components-Stage2":"view-views-Upload-components-Stage2","view-views-Upload-components-Stage3":"view-views-Upload-components-Stage3","view-views-Watch":"view-views-Watch"}[chunkId]||chunkId) + "." + {"view-assets-icon-iconfont":"31d6cfe0","view-assets-icon-iconfont-eot":"31d6cfe0","view-assets-icon-iconfont-json":"31d6cfe0","view-assets-icon-iconfont-svg":"31d6cfe0","view-assets-icon-iconfont-ttf":"31d6cfe0","view-assets-icon-iconfont-woff":"31d6cfe0","view-assets-icon-iconfont-woff2":"31d6cfe0","view-assets-images-bg-png":"31d6cfe0","view-assets-images-header-login_button-png":"31d6cfe0","view-assets-images-header-login_button_hover-png":"31d6cfe0","view-assets-images-home-l-focus-png":"31d6cfe0","view-assets-images-home-l-hover-png":"31d6cfe0","view-assets-images-home-l-normal-png":"31d6cfe0","view-assets-images-home-like-png":"31d6cfe0","view-assets-images-home-r-focus-png":"31d6cfe0","view-assets-images-home-r-hover-png":"31d6cfe0","view-assets-images-home-r-normal-png":"31d6cfe0","view-assets-images-home-search_bg-png":"31d6cfe0","view-assets-images-home-search_button-png":"31d6cfe0","view-assets-images-home-search_button_hover-png":"31d6cfe0","view-assets-images-home-search_button_icon-png":"31d6cfe0","view-assets-images-home-share-png":"31d6cfe0","view-assets-images-home-shares-png":"31d6cfe0","view-assets-images-home-sort_button_01-png":"31d6cfe0","view-assets-images-home-sort_button_01_hover-png":"31d6cfe0","view-assets-images-home-to_home-png":"31d6cfe0","view-assets-images-home-to_home_hover-png":"31d6cfe0","view-assets-images-login-modal-png":"31d6cfe0","view-assets-images-login-yostar-png":"31d6cfe0","view-assets-images-vote_mask-no-png":"31d6cfe0","view-assets-images-vote_mask-vote_bg-png":"31d6cfe0","view-assets-images-vote_mask-yes-png":"31d6cfe0","view-assets-images-watch-share-png":"31d6cfe0","view-assets-images-watch-share_hover-png":"31d6cfe0","view-assets-scss-variables-scss":"0e433876","view-components-Textarea":"7773154e","view-components-VoteMask":"803ed84a","view-components-toHome":"07abf753","view-views-404":"3f9e464e","view-views-Home":"510fb11c","view-views-Home-components-Pagination":"916a95c9","view-views-PrivacyPolicy":"ab2a73a5","view-views-Rules":"04ba9e58","view-views-TermsOfService":"8b11f046","view-views-Upload":"bb270547","view-views-Upload-components-Stage1":"f140e6c4","view-views-Upload-components-Stage2":"2509d192","view-views-Upload-components-Stage3":"6baf1079","view-views-Watch":"7a7567fb"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://webusstatic.yo-star.com/ark_us_web/dormdesign/prod/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
